<template>
  <footer class="footer" style="background:none;">
    <div class="container">
     <!-- <div class="text-center">
        <img src="/img/foot_logo.png" />
      </div>-->
      <nav>
        <ul style="margin-bottom: 12px;
    font-size: 12px;
    color: rgb(155 155 155) ">
         <!-- <li>
            서울시 성북구 종암로 13 고려대 교우회관 &nbsp;&nbsp;&nbsp;&nbsp;
            전화 : 1588-1905 &nbsp;&nbsp;&nbsp;&nbsp; 팩스 : 02-921-2590
          </li>-->
          <li>
            Copyright © 2020 Korea University Alumni Association. All Rights Reserved.
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
